import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useAppSelector } from 'flow/hooks/useRedux';
import { TicketKey } from 'flow/types/EntityKeys';
import { selectSubject } from 'flow/selectors/TicketsSelectors';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    ticketKey: TicketKey;
}

const TicketHeaderTitle = ({ ticketKey }: Props) => {
    const { i18next } = useAppContext();
    const subject = useAppSelector((state) => selectSubject(state, ticketKey));

    return (
        <div
            className={twMerge(
                'line-clamp-1 text-xl font-bold break-all',
                subject ? 'text-gray-800' : 'text-gray-400',
            )}
        >
            {subject || i18next.t('ticket.subject.none')}
        </div>
    );
};

export default React.memo(TicketHeaderTitle);
